/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const validateTypeFile = (file: any): boolean => {
  const fileName = file.toLowerCase()

  return (
    fileName.endsWith('.png') ||
    fileName.endsWith('.jpeg') ||
    fileName.endsWith('.jpg') ||
    fileName.endsWith('.pdf') ||
    fileName.endsWith('.jfif')
  )
}

export const isJSON = (str: string): boolean => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

export const isValidValue = (valor: any): boolean => {
  if (valor !== undefined && valor !== null) {
    if (Array.isArray(valor)) {
      return Array.from(valor).length > 0
    }
    if (Object.prototype.toString.call(valor) === '[object Object]') {
      return Object.values(valor).length > 0
    }

    if (typeof valor === 'string') {
      return valor !== ''
    }

    return true
  }
  return false
}

export const delay = (timer: number): Promise<void> => {
  // eslint-disable-next-line promise/param-names
  return new Promise(res => setTimeout(res, timer))
}
